import c from "./design-system.es126.js";
import m from "./design-system.es101.js";
import s from "./design-system.es100.js";
import { resolveComponent as r, openBlock as t, createBlock as o, withCtx as l, createElementBlock as d, Fragment as p, renderList as _ } from "vue";
/* empty css                    */
import f from "./design-system.es128.js";
const b = {
  name: "DsTabLinks",
  components: {
    TabHeader: m,
    TabHeaderLink: s
  },
  provide() {
    return { emitter: this.emitter };
  },
  props: {
    /**
     * List of tabs to render. Tabs contain { link, label, exact } strings.
     */
    tabs: Array,
    /**
     * Set to true to exclusively match for active class.
     */
    exact: Boolean
  },
  watch: {
    tabs: {
      handler() {
        this.emitter.emit("TAB_HEADER_TABS_UPDATED");
      },
      deep: !0
    }
  },
  beforeCreate() {
    this.emitter = c();
  },
  beforeUnmount() {
    this.emitter.off("*");
  }
};
function k(u, T, a, h, x, H) {
  const n = r("TabHeaderLink"), i = r("TabHeader");
  return t(), o(i, { class: "tab-links" }, {
    default: l(() => [
      (t(!0), d(p, null, _(a.tabs, (e) => (t(), o(n, {
        key: e.link,
        to: e.link,
        label: e.label,
        icon: e.icon,
        "data-qa": e.label,
        exact: a.exact
      }, null, 8, ["to", "label", "icon", "data-qa", "exact"]))), 128))
    ]),
    _: 1
  });
}
const C = /* @__PURE__ */ f(b, [["render", k], ["__scopeId", "data-v-f8c36a0a"]]);
export {
  C as default
};
//# sourceMappingURL=design-system.es98.js.map
